import React from 'react';

const InfoIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Iconly/Light/Info Square">
      <g id="Info Square">
        <path id="Stroke 1" fillRule="evenodd" clipRule="evenodd" d="M13.612 2.29199H6.38783C3.87033 2.29199 2.29199 4.07449 2.29199 6.59699V13.4037C2.29199 15.9262 3.86283 17.7087 6.38783 17.7087H13.6112C16.137 17.7087 17.7087 15.9262 17.7087 13.4037V6.59699C17.7087 4.07449 16.137 2.29199 13.612 2.29199Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path id="Stroke 3" d="M9.99609 13.3338V10.0005" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path id="Stroke 2" d="M9.99219 6.8374H10.0005" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </g>
  </svg>

);

export default InfoIcon;
